(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('wt-header-search')) {
    class WTHeaderSearch extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        this.summary = this.querySelector('summary');
        this.input = this.querySelector('input[type="search"]');

        if (!this.details || !this.summary) return;

        this.abortController = new AbortController();
        const signal = this.abortController.signal;

        this.details.addEventListener(
          'toggle',
          () => {
            if (this.details.open) {
              window.requestAnimationFrame(() => this.input?.focus());
            }
          },
          { signal }
        );

        document.addEventListener(
          'click',
          (event) => {
            if (this.details.open && !this.contains(event.target)) {
              this.details.open = false;
            }
          },
          { signal }
        );

        this.addEventListener(
          'keydown',
          (event) => {
            if (event.key === 'Escape' && this.details.open) {
              this.details.open = false;
              this.summary.focus();
            }
          },
          { signal }
        );
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }
    }

    customElements.define('wt-header-search', WTHeaderSearch);
  }

  if (!customElements.get('wt-header-root')) {
    class WTHeaderRoot extends HTMLElement {
      connectedCallback() {
        this.decorateMobileCtaLink();
      }

      normalizeUrl(value) {
        try {
          const url = new URL(value, window.location.origin);
          return `${url.pathname.replace(/\/$/, '') || '/'}${url.search}`;
        } catch (_error) {
          return value;
        }
      }

      decorateMobileCtaLink() {
        const ctaUrl = this.dataset.ctaUrl;
        const ctaText = this.dataset.ctaText;
        if (!ctaUrl || !ctaText) return;

        const targetUrl = this.normalizeUrl(ctaUrl);
        const links = Array.from(this.querySelectorAll('.menu-drawer a[href]'));

        let ctaLink =
          links.find((link) => this.normalizeUrl(link.getAttribute('href')) === targetUrl) ||
          links.find((link) => link.textContent.trim().toLowerCase().includes('quiz'));

        if (this.dataset.showMobileCta !== 'true') {
          if (ctaLink && ctaLink.textContent.trim().toLowerCase().includes('quiz')) {
            ctaLink.closest('li')?.remove();
          }
          return;
        }

        if (!ctaLink) {
          const menu = this.querySelector('.menu-drawer__menu');
          if (!menu) return;

          const item = document.createElement('li');
          item.className = 'wt-header-quiz-item';

          ctaLink = document.createElement('a');
          ctaLink.className = 'menu-drawer__menu-item link link--text focus-inset';
          item.appendChild(ctaLink);
          menu.appendChild(item);
        }

        /*
          Always force the configured CTA URL.
          The previous version changed the text of an existing Quiz link but
          could leave its old href in place.
        */
        ctaLink.setAttribute('href', ctaUrl);
        ctaLink.textContent = ctaText;
        ctaLink.classList.add('wt-header-quiz-button');
      }
    }

    customElements.define('wt-header-root', WTHeaderRoot);
  }

  } catch(e) { console.error(e); }
})();
})();
